import React from 'react';
import InvoiceForm from '../form/InvoiceForm';

const InvoiceUpdate = () => {
    return (
        <div>
            <InvoiceForm isUpdate/>
        </div>
    );
};

export default InvoiceUpdate;
